import { WorkerManager, WORKER_NAME } from 'Editor/services/WorkersManager/WorkerManager';
import { Proofing } from '../../models';
import BaseController from '../BaseController';

export class ProofingController extends BaseController {
  private proofing?: Proofing;
  private countSelectionWorker?: DODOC_WebWorker.DODOCWorker;

  start(documentId?: string): void {
    this.proofing = this.Data.models?.get(this.Data?.models.TYPE_NAME.PROOFING, `PR${documentId}`);
    this.proofing?.on('LOADED', (data) => {
      if (data) {
        this.Data.events?.emit('UPDATE_WORD_COUNT', data.summary, data.partials);
      }
    });
    this.proofing?.on('UPDATED', (data) => {
      if (data) {
        this.Data.events?.emit('UPDATE_WORD_COUNT', data.summary, data.partials);
      }
    });

    this.countSelectionWorker = WorkerManager.getInstance().getWorker(WORKER_NAME.PROOFING_WORKER);

    if (this.countSelectionWorker) {
      this.countSelectionWorker.onJobFinish(
        (summary: Editor.Data.Proofing.FullSummary | undefined) => {
          this.Data.events?.emit('COUNT_SELECTION', summary, {});
        },
      );
    }
  }

  stop(): void {}

  destroy(): void {
    if (this.proofing) {
      this.Data.models?.disposeModel(this.Data?.models.TYPE_NAME.PROOFING, this.proofing.id);
      delete this.proofing;
    }
    WorkerManager.getInstance().destroy();
  }

  countSelectionLocally(range?: Editor.Selection.RangeData) {
    if (!range) {
      return;
    }
    const childNodes = this.Data.structure?.getDocumentNodes() ?? [];
    const nodesToCount = new Map<string, Editor.Data.Node.Data | null>();
    const firstIndex: number = childNodes.indexOf(range.start.b);
    const lastIndex: number = childNodes.indexOf(range.end.b);

    for (let index = firstIndex; index <= lastIndex; index++) {
      const nodeId: string = childNodes[index];
      const element = this.Data.nodes?.getNodeModelById(nodeId);
      nodesToCount.set(nodeId, element?.selectedData() ?? null);
    }

    this.countSelectionWorker?.startJob({
      range,
      nodesToCount,
    });
  }

  getCountSelectionElements(range: Editor.Selection.RangeData[]) {
    return new Promise<Editor.Data.Proofing.FullSummary>((resolve, reject) => {
      this.Data.transport.dispatchEvent(
        'COUNT:SELECTED:ELEMENTS',
        { range },
        (response: Realtime.Transport.RealtimeResponse) => {
          if (response.success) {
            resolve(response.payload);
          } else {
            reject(response.error);
          }
        },
      );
    });
  }

  getCountWords() {
    return this.proofing?.getWordCount();
  }
}
